export const customV60 = [
  {
    name: 'customV2_startPageV37',
    hideHeader: true,
    progressTitle: 'customV2_progress_text11',
  },
  {
    name: 'start_page_age',
    hideProgress: true,
  },
  {
    name: 'customV2_policyPageV5',
    hideHeader: true,
  },
  {
    name: 'customV2_gender',
  },
  {
    name: 'customV2_breed',
  },
  {
    name: 'customV2_name',
  },
  {
    name: 'customV2_drinking',
  },
  {
    name: 'customV2_appetite',
  },
  {
    name: 'customV2_stool_changes',
  },
  {
    name: 'customV2_pain_signs',
  },
  {
    name: 'customV2_recent_exposure',
  },
  {
    name: 'customV2_info_health',
    separationStep: true,
    hideHeader: true,
    progressTitle: 'customV2_progress_text12',
  },

  {
    name: 'customV2_energy_level',
  },
  {
    name: 'customV2_scratching_licking',
  },
  {
    name: 'customV2_chewing_biting',
  },
  {
    name: 'customV2_sleep_changes',
  },
  {
    name: 'customV2_anxiety_restlessness',
  },
  {
    name: 'behavior_signals',
    separationStep: true,
    hideHeader: true,
    progressTitle: 'customV2_progress_text13',
  },
  {
    name: 'customV2_vaccination_status',
  },
  {
    name: 'customV2_medication',
  },
  {
    name: 'customV2_supplements',
  },
  {
    name: 'health_uncertainty',
  },
  {
    name: 'customV2_health_help_first',
  },
  {
    name: 'customV2_health_worries',
  },
  {
    name: 'info_about_worries',
    hideHeader: true,
  },
  {
    name: 'customV2_vet_access',
  },
  {
    name: 'customV2_late_night_worry',
  },
  {
    name: 'customV2_first_dog',
  },
  {
    name: 'age_group',
  },
  {
    name: 'statement_strong_bond',
    separationStep: true,
  },
  {
    name: 'customV2_creating_program',
    hideProgress: true,
  },
  {
    name: 'customV2_plan',
    hideProgress: true,
  },
  {
    name: 'customV2_email',
    hideProgress: true,
  },
  {
    name: 'receive_email',
    hideProgress: true,
  },
  {
    name: 'customV2_specialOffer_v2',
    hideProgress: true,
  },
];
